import _ from 'lodash';

export function getChangesFromArrayOfObject<Type>(array1: Type[], array2: Type[]): Type[] {
  const changes: Type[] = [];
  let i, item, j, len;
  if (_.isEqual(array1, array2)) {
    return changes;
  }

  for (i = j = 0, len = array2.length; j < len; i = ++j) {
    item = array2[i];
    const areEquals = _.isEqual(item, array1[i]);
    if (!areEquals) {
      changes.push(item);
    }
  }
  return changes;
}
